<template>
  <b-nav card-header tabs fill class="profile-nav flex-wrap-reverse">
    <b-nav-item
      link-classes="profile-nav-link"
      :to="{ name: 'ProfileStats', hash: '#stats', params: { id: $route.params.id } }"
      exact-active-class="active">
      <i class="fa fa-chart-line mr-1 mr-lg-2"></i>My Stats
    </b-nav-item>
    <b-nav-item
      link-classes="profile-nav-link"
      :to="{ name: 'ProfileInvites', hash: '#invites', params: { id: $route.params.id } }"
      exact-active-class="active">
      <i class="fa fa-envelope mr-1 mr-lg-2"></i>My Invites
    </b-nav-item>
    <b-nav-item
      link-classes="profile-nav-link"
      :to="{ name: 'ProfileProjects', hash: '#projects', params: { id: $route.params.id } }"
      exact-active-class="active">
      <CitSciProjectIcon/>
      My Projects
    </b-nav-item>
    <b-nav-item-dropdown :toggle-class="isDataActive" right>
      <template #button-content>
        <i class="fa fa-binoculars mr-1 mr-lg-2"></i>
        My Data
      </template>
      <b-dropdown-item
        :to="{ name: 'ProfileObservations', hash: '#observations', params: { id: $route.params.id } }"
        exact-active-class="active">
        <i class="fa fa-binoculars mr-1 mr-lg-2"></i>Observations
      </b-dropdown-item>
      <b-dropdown-item
        :to="{ name: 'ProfileAssignedLocations', hash: '#locations', params: { id: $route.params.id } }"
        exact-active-class="active">
        <i class="fa fa-map-marker-alt mr-1 mr-lg-2"></i>Assigned Locations
      </b-dropdown-item>
      <b-dropdown-item
        :to="{ name: 'ProfileDownloads', hash: '#downloads', params: { id: $route.params.id } }"
        exact-active-class="active">
        <i class="fa fa-download mr-1 mr-lg-2"></i>Downloads
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <b-nav-item
      link-classes="profile-nav-link"
      :to="{ name: 'ProfilePreferences', hash: '#preferences', params: { id: $route.params.id } }"
      exact-active-class="active">
      <i class="fa fa-gear mr-1 mr-lg-2"></i>My Preferences
    </b-nav-item>
  </b-nav>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CitSciProjectIcon from "../../common/CitSciProjectIcon.vue";

export default {
  components: {CitSciProjectIcon},
  computed: {
    ...mapGetters({
      isAdmin: "user/profile/isAdmin",
    }),
    isDataActive() {
      const data = [
        "ProfileObservations",
        "ProfileAssignedLocations",
        "ProfileMap",
        "ProfileDownloads"
      ];
      if (data.includes(this.$route.name)) {
        return "active";
      }
      return "profile-nav-link";
    },
  }
};
</script>

<style lang="scss">
.profile-nav-link {
  color: #3b3b3b;

  &:hover {
    color: #007fb1;
  }
}

.admin-link {
  color: #dc3545 !important;

  &:hover {
    color: #c82333 !important;
  }
}
</style>
